module.exports = __webpack_public_path__ + "img/portrait-061.16d85215.jpg";